module.exports = __webpack_public_path__ + "components/home-header/static/header-5--large-2af703c2000a80b67798c4daaa0724c4.jpg";